// https://prototype.sqprod.co/#/docs/squareup.franklin.api.FormBlocker.Element.PaymentPlanSummaryElement

import styled from '@emotion/styled'
import { v4 as uuidv4 } from 'uuid'

import { ArcadeBorderedCard, Flex, PaddingInset, spacing, Stack, Text } from '@cash-design-system/react'
import { FormBlockerElementPaymentPlanSummaryElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'
import { useArcadeMigrationFeatureFlag } from '@cash-web/shared-data-access-arcade-migration'
import { NestedCard } from '@cash-web/shared-feature-common'
import { useTextTokenizer } from '@cash-web/shared-feature-use-text-tokenizer'

import { DetailRowElement } from '../DetailRowElement/DetailRowElement'

type PaymentPlanSummaryElementProps = FormBlockerElementPaymentPlanSummaryElement

const Card = styled(NestedCard)`
  border-radius: 1rem;
  width: 100%;
`

export function PaymentPlanSummaryElement({ header, items }: PaymentPlanSummaryElementProps) {
  const textTokenizer = useTextTokenizer()
  const isArcadeMigrationEnabled = useArcadeMigrationFeatureFlag('apps')

  const title = (
    <Text as="p" typography="titleBarPageTitle">
      {textTokenizer(header)}
    </Text>
  )

  if (!header || !items || items.length < 1) return null

  if (isArcadeMigrationEnabled)
    return (
      <ArcadeBorderedCard data-testid="arcade-card">
        <Flex flexDirection="column" gap={spacing.xs}>
          <Text typography="sectionTitle" color="textStandard">
            {header}
          </Text>
          {items?.map(item => {
            const key = uuidv4()
            return (
              <Text key={key} typography="bodySmall" color="cellBodyDefault">
                <DetailRowElement {...item} />
              </Text>
            )
          })}
        </Flex>
      </ArcadeBorderedCard>
    )
  return (
    <Card>
      <Stack space={spacing.l} data-testid="no-arcade">
        <PaddingInset>{title}</PaddingInset>
        <div>
          {items?.map(item => {
            const key = uuidv4()
            return <DetailRowElement key={key} {...item} />
          })}
        </div>
      </Stack>
    </Card>
  )
}
